import styled from 'styled-components';
import primitives from '@veneer/primitives';
import { Search as VeneerSearch } from '@veneer/core';
import { GenericModal, mixins } from '@jarvis/react-portal-addons';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitives.layout.size2}px;

  ${mixins.veneer.sm(`
    gap: ${primitives.layout.size5}px;
  `)}
`;

export const Timestamp = styled.span`
  color: ${props => (props.red ? primitives.color.red6 : '')};
`;

export const SearchContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: ${primitives.layout.size2}px;
    width: 100%;

    ${mixins.veneer.md(`
      flex-direction: row;
      align-items: flex-end;
      gap: ${primitives.layout.size5}px;
      flex-wrap: nowrap;
    `)}
  }
`;

export const SelectWrapper = styled.div`
  && {
    flex: 0 0 auto;
    width: 100%;

    ${mixins.veneer.md(`
      width: 150px;
    `)}

    ${mixins.veneer.lg(`
      width: 160px;
    `)}
  }
`;

export const SearchWrapper = styled.div`
  && {
    width: 100%;
    max-width: 100%;

    ${mixins.md(`
      min-width: 0;
      max-width: 380px;
    `)}

    ${mixins.lg(`
      max-width: 430px;
    `)}

    ${mixins.xl(`
      max-width: 480px;
    `)}

    ${mixins.xxl(`
      max-width: 520px;
    `)}

    ${mixins.veneer.xxl(`
      max-width: 600px;
    `)}
  }
`;

export const Search = styled(VeneerSearch)`
  width: 100%;

  & #search-model-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledGenericModal = styled(GenericModal)`
  && {
    margin: ${primitives.layout.size4}px auto;
    max-width: calc(100% - ${primitives.layout.size4 * 2}px);
    width: calc(100% - ${primitives.layout.size4 * 2}px);
    padding: 40px ${primitives.layout.size5}px;

    ${mixins.xs(`
      margin: ${primitives.layout.size4}px auto;
      width: calc(100% - ${primitives.layout.size4 * 2}px);
    `)}

    ${mixins.sm(`
      margin: ${primitives.layout.size4}px auto;
      width: calc(100% - ${primitives.layout.size4 * 2}px);
    `)}

    ${mixins.md(`
      width: calc(100% - ${primitives.layout.size8}px);
    `)}

    ${mixins.lg(`
      width: calc(100% - ${primitives.layout.size4 * 3}px);
      padding: 40px ${primitives.layout.size6}px;
    `)}

    ${mixins.xl(`
      width: calc(100% - ${primitives.layout.size4 * 2}px);
      padding: 40px ${primitives.layout.size5}px;
    `)}

    ${mixins.xxl(`
      width: calc(100% - ${primitives.layout.size4 * 2}px);
      padding: 40px ${primitives.layout.size5}px;
    `)}

    ${mixins.veneer.xxl(`
      width: 1660px;
      max-width: 1660px;
      padding: ${primitives.layout.size5 * 2}px;
      margin: ${primitives.layout.size4}px auto;
    `)}
  }
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitives.layout.size4}px;

  ${mixins.veneer.xxl(`
    gap: ${primitives.layout.size4}px;
  `)}
`;
